import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FirebaseContext from "../firebase/firebaseContext";

const StudentInfo = () => {
  const firebaseContext = useContext(FirebaseContext);
  const { auth, db } = firebaseContext;
  const [user, setUser] = useState({});
  const [task, setTask] = useState(false);

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        const reference = db.collection("students").doc(user.uid);
        reference
          .get()
          .then(function (doc) {
            if (doc.exists) {
              setUser(doc.data());
            } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
            }
          })
          .catch(function (error) {
            console.log("Error getting document:", error);
          });
      }
    });
  }, []);

  const taskFinished = (e) => {
    e.preventDefault();
    db.collection("students")
      .doc(user.id)
      .update({ ...user, task: true })
      .then(() => {
        setUser({ ...user, task: true });
      });
  };

  const taskCorrected = (e) => {
    e.preventDefault();
    db.collection("students")
      .doc(user.id)
      .update({ ...user, task: false, points: user.points + 1 });
  };

  return (
    <div className='student-container'>
      <h1>{user.name + "'" + "s"} NOTEBOOK</h1>
      <div className='student-info'>
        <p className='ucenec'>Učenec: {user.name}</p>
        <p className='razred'>Razred: {user.class}</p>
      <p className="naloge">Vsako spremembo, ki jo v dokumentu narediš, vidi učitelj. Nalog ni potrebno
      več "ODDAJATI".</p>
      </div>
      <div className='student-docs'>
        {user.source ? (
          <iframe
            src={user.source}
            frameborder='0'
            width='1920'
            height='560'
            allowfullscreen='true'
            mozallowfullscreen='true'
            webkitallowfullscreen='true'
          ></iframe>
        ) : (
          <p style={{ fontSize: "3rem" }}>
            Svojega zvezka še ne vidiš. Počakaj, da ti ga učitelj ustvari.
          </p>
        )}
      </div>
    </div>
  );
};

export default StudentInfo;
